import { type Actor, can, hasAnyRole } from '@hrms/shared'
import { LuLayoutGrid } from 'react-icons/lu'
import { hrDeskModule } from './hr-desk/index.tsx'
import type { AppModule, ComingSoonModule, ModuleNavItem } from './types.ts'

/** Registered modules, in nav order. Add a module by importing it here. */
export const MODULES: AppModule[] = [hrDeskModule]

export const COMING_SOON: ComingSoonModule[] = [
  {
    id: 'more',
    name: 'More modules',
    icon: LuLayoutGrid,
    hint: 'Coming soon: more tools will appear here',
  },
]

export function joinPath(base: string, path: string): string {
  return `/${[base, path]
    .map((p) => p.replace(/^\/+|\/+$/g, ''))
    .filter(Boolean)
    .join('/')}`
}

export interface VisibleModule extends AppModule {
  visibleItems: ModuleNavItem[]
}

function itemVisible(actor: Actor, item: ModuleNavItem): boolean {
  return hasAnyRole(actor.role, item.roles) && (!item.permission || can(actor, item.permission))
}

/** Modules and nav items the given user can see. */
export function visibleModules(actor: Actor): VisibleModule[] {
  return MODULES.filter((m) => hasAnyRole(actor.role, m.roles))
    .map((m) => ({ ...m, visibleItems: m.navItems.filter((i) => itemVisible(actor, i)) }))
    .filter((m) => m.visibleItems.length > 0)
}

/** First page a user should land on (member → My tickets; HR and viewers → Tickets). */
export function defaultPath(actor: Actor): string {
  const first = visibleModules(actor)[0]
  if (!first) return '/'
  const path = first.landing?.(actor) ?? first.visibleItems[0]?.path
  return path === undefined ? '/' : joinPath(first.basePath, path)
}
